// Production ve development URL'leri
const BASE_URL = process.env.NODE_ENV === 'production' 
  ? "https://bruceuzbekistan.uz/api" 
  : "http://127.0.0.1:8000/api";

const MEDIA_URL = process.env.NODE_ENV === 'production'
  ? "https://bruceuzbekistan.uz"
  : "http://127.0.0.1:8000";

// CSRF token'ı cookie'den almak için helper fonksiyon
const getCsrfToken = () => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrftoken') {
      return value;
    }
  }
  return null;
};

// CSRF token'ı backend'den al ve cookie'ye kaydet
export const initializeCsrfToken = async () => {
  try {
    const response = await fetch(`${BASE_URL}/csrf-token/`, {
      credentials: 'include'
    });
    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.warn('CSRF token alınamadı:', error);
  }
  return null;
};

// Dil parametresi eklemek için helper function
const addLanguageParam = (url, language = 'uz') => {
  const separator = url.includes('?') ? '&' : '?';
  const fullUrl = `${url}${separator}lang=${language}`;
  console.log('API URL oluşturuluyor:', fullUrl);
  return fullUrl;
};

// Helper to process image URLs
const processImageUrls = (item, fields) => {
    const newItem = { ...item };
    fields.forEach(field => {
        if (newItem[field] && !newItem[field].startsWith('http')) {
            newItem[field] = MEDIA_URL + newItem[field];
        }
    });
    return newItem;
};

// Tüm ürünleri getir
export const fetchProducts = async (language = 'uz') => {
  const url = addLanguageParam(`${BASE_URL}/products/`, language);
  const response = await fetch(url);
  if (!response.ok) throw new Error("Mahsulotlar yuklanmadi");
  const data = await response.json();
  console.log('fetchProducts sonucu:', data);
  return data.map(product => processImageUrls(product, ['image1', 'image2']));
};

// ID ile tek bir ürün getir
export const fetchProductById = async (id, language = 'uz') => {
  const url = addLanguageParam(`${BASE_URL}/products/${id}/`, language);
  const response = await fetch(url);
  if (!response.ok) throw new Error("Mahsulot topilmadi");
  const data = await response.json();
  return processImageUrls(data, ['image1', 'image2']);
};

// Kategorileri getir
export const fetchCategories = async (language = 'uz') => {
  const url = addLanguageParam(`${BASE_URL}/products/categories/`, language);
  const response = await fetch(url);
  if (!response.ok) throw new Error("Kategoriyalar yuklanmadi");
  return await response.json();
};

// Hakkımızda verisini getir
export const fetchAbout = async (language = 'uz') => {
  const url = addLanguageParam(`${BASE_URL}/contact/about/`, language);
  const response = await fetch(url);
  if (!response.ok) throw new Error("Haqida ma'lumot yuklanmadi");
  const data = await response.json();
  
  // API'den gelen veri dizi ise map'le, tekil nesne ise diziye çevirip işle
  if (Array.isArray(data)) {
    return data.map(item => processImageUrls(item, ['image']));
  } else if (data && typeof data === 'object') {
    return [processImageUrls(data, ['image'])];
  }
  return []; // Beklenmedik bir format ise boş dizi döndür
};

// İletişim mesajı gönder (POST)
export const sendContactMessage = async (data) => {
  const csrfToken = getCsrfToken();
  const headers = { "Content-Type": "application/json" };
  
  if (csrfToken) {
    headers['X-CSRFToken'] = csrfToken;
  }
  
  const response = await fetch(`${BASE_URL}/contact/`, {
    method: "POST",
    headers,
    credentials: 'include',
    body: JSON.stringify(data)
  });
  if (!response.ok) throw new Error("Xabar yuborilmadi");
  return await response.json();
};

// Sipariş oluştur (POST)
export const createOrder = async (orderData) => {
  const csrfToken = getCsrfToken();
  const headers = { "Content-Type": "application/json" };
  
  if (csrfToken) {
    headers['X-CSRFToken'] = csrfToken;
  }
  
  const response = await fetch(`${BASE_URL}/orders/`, {
    method: "POST",
    headers,
    credentials: 'include',
    body: JSON.stringify(orderData)
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || "Sipariş oluşturulamadı");
  }
  return await response.json();
};

// Tüm yangiliklar getir
export const fetchNews = async (language = 'uz') => {
  const url = addLanguageParam(`${BASE_URL}/news/`, language);
  const response = await fetch(url);
  if (!response.ok) throw new Error("Yangiliklar yuklanmadi");
  const data = await response.json();
  return data.map(news => processImageUrls(news, ['image']));
};

// ID ile tek bir yangilik getir
export const fetchNewsById = async (id, language = 'uz') => {
  const url = addLanguageParam(`${BASE_URL}/news/${id}/`, language);
  const response = await fetch(url);
  if (!response.ok) throw new Error("Yangilik topilmadi");
  const data = await response.json();
  return processImageUrls(data, ['image']);
};

// Asosiy yangiliklar getir
export const fetchFeaturedNews = async (language = 'uz') => {
  const url = addLanguageParam(`${BASE_URL}/news/featured/`, language);
  const response = await fetch(url);
  if (!response.ok) throw new Error("Asosiy yangiliklar yuklanmadi");
  const data = await response.json();
  return data.map(news => processImageUrls(news, ['image']));
};

// Sliderlar getir
export const fetchSliders = async (language = 'uz') => {
  const url = addLanguageParam(`${BASE_URL}/sliders/`, language);
  const response = await fetch(url);
  if (!response.ok) throw new Error("Slayderlar yuklanmadi");
  const data = await response.json();
  return data.map(slider => processImageUrls(slider, ['image']));
};

// Ürüne ait yorumları getir
export const fetchReviewsForProduct = async (productId) => {
  const response = await fetch(`${BASE_URL}/products/${productId}/reviews/`);
  if (!response.ok) throw new Error("Yorumlar yuklanmadi");
  return await response.json();
};

// Ürüne yorum ekle (POST)
export const createReview = async (productId, reviewData) => {
  const csrfToken = getCsrfToken();
  const headers = { "Content-Type": "application/json" };
  
  if (csrfToken) {
    headers['X-CSRFToken'] = csrfToken;
  }
  
  const response = await fetch(`${BASE_URL}/products/${productId}/reviews/`, {
    method: "POST",
    headers,
    credentials: 'include',
    body: JSON.stringify(reviewData)
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || "Yorum eklenemedi");
  }
  return await response.json();
};
